<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-end align-center"></div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-simple-table dense style="border: 1px solid #d1d1d1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left caption">CÓDIGO</th>
                <th class="text-left caption">CUENTA</th>
                <th class="text-right caption">SUBTOTAL GESTIÓN</th>
                <th class="text-right caption">DESERCIÓN GESTIÓN</th>
                <th class="text-right caption">TOTAL GESTIÓN</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="estimacion in estimacionesPorPartidas" :key="estimacion.codigo">
                <td class="text-left caption">{{ estimacion.codigo }}</td>
                <td class="text-left caption">{{ estimacion.clasificador_nombre }}</td>
                <td class="text-right caption">
                  {{ formatearNumero(estimacion.subtotal_gestion) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(estimacion.desercion_gestion) }}
                </td>
                <td class="text-right caption">{{ formatearNumero(estimacion.total_gestion) }}</td>
              </tr>

              <tr>
                <td></td>
                <td class="font-weight-bold">TOTALES</td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacionesPorPartidas.reduce((a, b) => a + parseFloat(b.subtotal_gestion), 0).toFixed(2),
                    )
                  }}
                </td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacionesPorPartidas.reduce((a, b) => a + parseFloat(b.desercion_gestion), 0).toFixed(2),
                    )
                  }}
                </td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacionesPorPartidas.reduce((a, b) => a + parseFloat(b.total_gestion), 0).toFixed(2),
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatearNumero } from './../../utils.js';

export default {
  name: 'TotalesPorPartida',
  props: {
    estimacionesPorPartidas: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatearNumero,
  },
};
</script>

<style>
</style>